import React from "react";
var BasicProfileErrorMsg = function (props) {
    return (React.createElement("div", { className: "basic-error-msg flexCenter txt_primaryGrey" },
        React.createElement("div", null,
            React.createElement("i", { className: "edel-icon-likes1" })),
        React.createElement("div", { className: "mgl-5 DMSanN_14_400 error-text" },
            "You don\u2019t have any ",
            props.errorName)));
};
export default BasicProfileErrorMsg;
